import React, { Fragment, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";

import { Card } from "reactstrap";
import { Btn, LI } from "../../../AbstractElements";
import { LogOut } from "react-feather";

import { logout } from "../../../MyApi/logout";


import { toast } from "react-toastify";
import AuthContext from "../../../_helper/auth";

const LogoutClass = () => {
  const {authenticated,setAuthenticated}=useContext(AuthContext)
  const {t}=useTranslation()
  const navigate = useNavigate(); 
  
  const mutation = useMutation("logout", (data) => logout(data), {
    onSuccess: () => {  
       localStorage.clear(); 
      setAuthenticated(false) 
  
      toast.success(t("Logout successfully")); 

    },
  });


  const handleLogout = () =>{
    const token = localStorage.getItem("token");
    mutation.mutate({
      token,
    });
  };
  return (
    <Fragment>
      <LI attrLI={{ className: "onhover-dropdown p-0", onClick: handleLogout }}>
        <Btn
          attrBtn={{
            as: Card.Header,
            className: "btn btn-primary-light",
            color: "default",
          }}
        >

            <LogOut />
          {t("Log out")}
        
        </Btn>
      </LI>
    </Fragment>
  );
};

export default LogoutClass;
